import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './contact-us-tab.component.html';
var ContactUsTabComponent = (function () {
    function ContactUsTabComponent() {
    }
    ContactUsTabComponent.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ContactUsTabComponent.prototype, "configuration", void 0);
    ContactUsTabComponent = __decorate([
        Component({
            selector: 'contactUsTab',
            template: template,
        })
    ], ContactUsTabComponent);
    return ContactUsTabComponent;
}());
export { ContactUsTabComponent };
